import uuid from 'node-uuid';
import AppDispatcher from '../dispatcher/AppDispatcher';

export const SET_SME_PAYMENT_LIST = 'SET_SME_PAYMENT_LIST';
export const SET_TO_ACCOUNT_AFTER_ADD_PAYEE = 'SET_TO_ACCOUNT_AFTER_ADD_PAYEE';
export const SET_SME_PAYMENT_LIST_AFTER_ADD_PAYEE =
  'SET_SME_PAYMENT_LIST_AFTER_ADD_PAYEE';
export const SET_SME_BACK_URL = 'SET_SME_BACK_URL';
export const RESET_SME_BACK_URL = 'RESET_SME_BACK_URL';
export const SET_PAYMENT_AUTH_LIST = 'SET_PAYMENT_AUTH_LIST';
export const SET_PAYMENT_AUTH_TO_EDIT_BY_ID = 'SET_PAYMENT_AUTH_TO_EDIT_BY_ID';
export const SET_MANDATE_TO_EDIT = 'SET_MANDATE_TO_EDIT';
export const RESET_PAYMENT_AUTH_LIST = 'RESET_PAYMENT_AUTH_LIST';
export const SET_PAYMENT_TO_EDIT_BY_ID = 'SET_PAYMENT_TO_EDIT_BY_ID';

export const setSMEPaymentToAccount = ({ id, reference }) => {
  AppDispatcher.handleServerAction({
    actionType: SET_TO_ACCOUNT_AFTER_ADD_PAYEE,
    data: {
      toAccount: id,
      reference,
    },
  });
};

export const setSMEPaymentList = (paymentType, paymentsWithDetails) => {
  AppDispatcher.handleServerAction({
    actionType: SET_SME_PAYMENT_LIST,
    data: {
      paymentType,
      paymentsWithDetails,
    },
  });
};

export const setPaymentAuthList = (paymentType, paymentsWithDetails) => {
  AppDispatcher.handleServerAction({
    actionType: SET_PAYMENT_AUTH_LIST,
    data: {
      paymentType,
      paymentsWithDetails,
    },
  });
};

export const setPaymentAuthToEdit = (paymentType, paymentToEdit) => {
  AppDispatcher.handleServerAction({
    actionType: SET_PAYMENT_AUTH_TO_EDIT_BY_ID,
    data: {
      paymentType,
      paymentToEdit,
    },
  });
};

export const setPaymentToEditById = (paymentType, paymentToEdit) => {
  AppDispatcher.handleServerAction({
    actionType: SET_PAYMENT_TO_EDIT_BY_ID,
    data: {
      paymentType,
      paymentToEdit,
    },
  });
};

export const resetPaymentAuthList = () => {
  AppDispatcher.handleServerAction({
    actionType: RESET_PAYMENT_AUTH_LIST,
  });
};
export const setSMEPaymentAddPayee = (payment) => {
  AppDispatcher.handleServerAction({
    actionType: SET_SME_PAYMENT_LIST_AFTER_ADD_PAYEE,
    data: {
      id: uuid.v1(),
      ...payment,
    },
  });
};

export const setSMEBackUrl = (backUrl) => {
  AppDispatcher.handleServerAction({
    actionType: SET_SME_BACK_URL,
    data: backUrl,
  });
};

export const setMandateToEdit = (mandate) => {
  AppDispatcher.handleServerAction({
    actionType: SET_MANDATE_TO_EDIT,
    data: mandate,
  });
};

export const resetSMEBackUrl = () => {
  AppDispatcher.handleServerAction({
    actionType: RESET_SME_BACK_URL,
  });
};
